import React from 'react';

import './NotFound.css';

const NotFound = () => {
    return (
        <div className="not-found" >
            <h1>404</h1>
            <h2>Not Found</h2>
        </div>
    );
};

export default NotFound;